import {useEffect, useMemo} from 'react'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {useChatState} from '@github-ui/copilot-chat/CopilotChatContext'
import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'

const PROTECTED_ORGS_CACHE_KEY = 'PROTECTED_ORGS'

/**
 * Custom hook to detect SSO changes and clear relevant cache.
 *
 * When a user logs in or out of SSO orgs we should:
 * - Clear auth token from localStorage
 * - Clear cached tasks from localStorage
 * - Invalidate React Query cache to force a refetch
 */
export function useSSOChangeDetection() {
  const {ssoOrganizations} = useChatState()

  // Sort the orgs to prevent unnecessary effect re-runs
  const allProtectedOrgs = useMemo(() => {
    return (ssoOrganizations ?? []).map(org => org.login).sort()
  }, [ssoOrganizations])

  const currentOrgsString = useMemo(() => JSON.stringify(allProtectedOrgs), [allProtectedOrgs])

  useEffect(() => {
    const prevOrgsString = sessionStorage.getItem(PROTECTED_ORGS_CACHE_KEY)

    // Setting the orgs on initial load
    if (prevOrgsString === null) {
      sessionStorage.setItem(PROTECTED_ORGS_CACHE_KEY, currentOrgsString)
      return
    }

    if (currentOrgsString === prevOrgsString) {
      return
    }

    const tokenProvider = new AgentSessionsTokenProvider()
    tokenProvider.removeLocalStorageAuthToken()
    sessionStorage.setItem(PROTECTED_ORGS_CACHE_KEY, currentOrgsString)
  }, [currentOrgsString])
}
